import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title } from "utils";

import { Header, SubmissionsGraphs } from "components";

class DataSubmissionsPage extends Component {
  render() {
    const bread = [{ text: "Data soumission" }];

    return (
      <Fragment>
        <Helmet>{title("Data soumission")}</Helmet>

        <div className="data-submissions-page main-content">
          <Header title="Data soumission" bread={bread} />

          <div className="dashestimation-layout right">
            <SubmissionsGraphs filtersAlwaysOpen syncFiltersToUrl />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default DataSubmissionsPage;
